module.exports = __webpack_public_path__ + "img/gz02.172933a8.png";